import React, { useEffect, useState } from 'react';

import CabBookingForm from '@/components/booking/CabBookingForm';

import { HERO } from '@/config/hero';

import { BRAND } from '@/theme/brand';

import { useIsMobile } from '@/hooks/useIsMobile';



const AtithiHeroSection = () => {

  const [useImage, setUseImage] = useState(HERO.mode === 'image');

  const [videoFallback, setVideoFallback] = useState(null);

  const isMobile = useIsMobile(768);



  useEffect(() => {

    if (typeof window.AOS !== 'undefined') {

      window.AOS.refresh();

    }

  }, []);



  const handleVideoError = () => {

    if (videoFallback === 'legacy') {

      setUseImage(true);

      return;

    }

    if (videoFallback === 'mobile-desktop') {

      setVideoFallback('legacy');

      return;

    }

    if (isMobile) {

      setVideoFallback('mobile-desktop');

    } else {

      setVideoFallback('legacy');

    }

  };



  const resolvedVideoSrc = (() => {

    if (useImage) return null;

    if (videoFallback === 'legacy') return HERO.video.legacy;

    if (videoFallback === 'mobile-desktop') return HERO.video.desktop;

    return isMobile ? HERO.video.mobile : HERO.video.desktop;

  })();



  return (

    <section className="relative w-full bg-[#F8F4EE]" aria-label="Book your cab">

      <div

        className="relative w-full min-h-[100dvh] flex flex-col"

        style={{ backgroundColor: BRAND.colors.navyDark }}

      >

        <div className="absolute inset-0 overflow-hidden">

          {useImage ? (

            <img

              key={isMobile ? HERO.image.mobile : HERO.image.desktop}

              src={isMobile ? HERO.image.mobile : HERO.image.desktop}

              alt={HERO.image.alt}

              className="absolute inset-0 w-full h-full object-cover"

              onError={(e) => {

                const img = e.currentTarget;

                if (img.src !== HERO.image.fallback) img.src = HERO.image.fallback;

                else if (HERO.video.poster) img.src = HERO.video.poster;

              }}

            />

          ) : (

            <video

              key={resolvedVideoSrc}

              autoPlay

              muted

              loop

              playsInline

              preload="auto"

              poster={HERO.video.poster}

              className="absolute inset-0 w-full h-full object-cover"

              onError={handleVideoError}

            >

              <source src={resolvedVideoSrc} type="video/mp4" />

            </video>

          )}



          <div

            className="absolute inset-0 pointer-events-none"

            style={{

              background: `linear-gradient(to bottom, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.55) 55%, rgba(0,0,0,0.7) 100%)`,

            }}

          />

          <div

            className="absolute inset-0 pointer-events-none"

            style={{ backgroundColor: 'rgba(13, 27, 62, 0.28)' }}

          />

        </div>



        <div className="relative z-10 flex flex-col items-center justify-center flex-1 w-full max-w-5xl mx-auto px-4 sm:px-6 pt-28 pb-8 lg:pt-32 lg:pb-10 text-center gap-5 lg:gap-6">

          <div className="flex flex-col items-center w-full">

            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full mb-4 lg:mb-5">

              <span

                className="w-2 h-2 rounded-full animate-pulse inline-block"

                style={{ backgroundColor: BRAND.colors.saffron }}

              />

              Gujarat&apos;s No.1 Trusted Taxi Service

            </div>



            <h1

              className="font-black text-white leading-tight tracking-tight mb-3 lg:mb-4"

              style={{

                fontSize: 'clamp(28px,5vw,64px)',

                letterSpacing: '-2px',

              }}

            >

              Your Journey,

              <span className="block" style={{ color: BRAND.colors.saffron }}>

                Just a Tap Away

              </span>

            </h1>



            <p className="text-white/75 text-sm lg:text-base mb-2 max-w-xl leading-relaxed">

              Book reliable taxis across Gujarat — Ahmedabad, Surat, Rajkot, Jamnagar, Somnath &amp; beyond

            </p>

          </div>



          <div id="booking" aria-hidden="true" className="sr-only" />



          <div

            id="booking-form"

            className="w-full bg-white rounded-2xl p-4 lg:p-6 shadow-[0_24px_64px_rgba(0,0,0,0.35)] text-left"

          >

            <CabBookingForm leadSource="Homepage" variant="hero" />

          </div>

        </div>



        <div className="relative z-10 w-full shrink-0 pointer-events-none leading-[0]">

          <svg

            viewBox="0 0 1440 60"

            fill="none"

            xmlns="http://www.w3.org/2000/svg"

            className="w-full block"

            preserveAspectRatio="none"

            style={{ height: '48px' }}

            aria-hidden

          >

            <path d="M0,60 L0,30 Q360,0 720,30 Q1080,60 1440,20 L1440,60 Z" fill="#F8F4EE" />

          </svg>

        </div>

      </div>

    </section>

  );

};



export default AtithiHeroSection;

